<app-menus></app-menus>
<app-modulo-aplicacion></app-modulo-aplicacion>
<app-contacto></app-contacto>
<app-avisos [avisos]="avisos"></app-avisos>
<app-noticias [noticias]="noticias"></app-noticias>
<app-simbologia></app-simbologia>
<app-profile></app-profile>
<app-guia></app-guia>

<p-confirmDialog [baseZIndex]="10000" rejectButtonStyleClass="p-button-text p-button-secondary p-button-sm"
  acceptButtonStyleClass="p-button-sm" [closable]="false">
</p-confirmDialog>

<!-- HEADER -->
<p-toolbar class="toolbar-project">
  <!-- MOBILE -->
  <div class="toolbar-mobile d-xs-block d-sm-block d-md-block d-lg-none">
    <div class="text-white d-xs-block d-md-block">
      <img src="https://repositorio.uv.cl/imagenes/logouv/logo_uv_40px.png"  />
      <img src="https://repositorio.uv.cl/imagenes/logouv/logo-ac6-blanco.png" class="escudo_uv" />
      {{ title }}
    </div>
  </div>

  <div class="p-toolbar-group-left">
    <!-- MENUS (NAVEGACION) -->
    <button (click)="show_menus_sidebar()" icon="{{ _config.getIcon('navegacion') }}" pButton pRipple type="button"
      class="p-button-rounded p-button-text p-sm p-mr-2"
      [ngClass]="!tokenError && !maintenance ? 'text-white button-header' : ''"
      *ngIf="config.SISTEMA.LOADS.MENUS.BUTTON" title="{{ 'menus.titulo' | translate }}"></button>

    <!-- LOGO INSTITUCIONAL -->
    <img src="https://repositorio.uv.cl/imagenes/logouv/logo_uv_40px.png" class="d-none d-lg-block" />
    <img width='220px' src="https://repositorio.uv.cl/imagenes/logouv/logo-ac6-blanco.png" class="d-none d-lg-block" />

    <p-divider layout="vertical" class="d-none d-lg-block p-divider-header"></p-divider>

    <!-- NOMBRE SISTEMA (DESKTOP) -->
    <div class="text-white d-none d-lg-block title-system">{{ title }}</div>
  </div>

  <div class="p-toolbar-group-right">
    <!-- VOLVER AL PORTAL -->
    <ng-container *ngIf="config.SISTEMA.LOADS.VOLVER_PORTAL.BUTTON">
      <button pButton pRipple type="button" label="Portal" icon="{{ _config.getIcon('goback_portal') }}"
        class="p-button-text p-ml-2 p-sm d-none d-lg-block" [ngClass]="!tokenError ? 'text-white button-header' : ''"
        (click)="backToPortal(); hideSidebar()" title="{{ 'button.volver_al_portal.label' | translate }}"
        [disabled]="tokenError"></button>
      <button pButton pRipple type="button" icon="{{ _config.getIcon('goback_portal') }}"
        class="p-button-rounded p-ml-2 p-button-text p-sm d-xs-block d-sm-block d-md-block d-lg-none"
        [ngClass]="!tokenError ? 'text-white button-header' : ''" (click)="backToPortal(); hideSidebar()"
        title="{{ 'button.volver_al_portal.label' | translate }}" [disabled]="tokenError"></button>
    </ng-container>

    <!-- NOTICIAS -->
    <button pButton pRipple type="button" icon="{{ _config.getIcon('noticias') }}" class="p-ml-2 p-button-text p-sm"
      [ngClass]="
        !tokenError || noticias.length > 0 ? 'text-white button-header' : ''
      " [popover]="noticiasPopover" popoverTitle="{{ 'noticias_avisos.noticias.titulo' | translate }}"
      containerClass="popoverHeader" *ngIf="config.SISTEMA.LOADS.NOTICIAS.BUTTON" [disabled]="tokenError"
      [outsideClick]="true" (click)="hideSidebar()" title="{{ 'noticias_avisos.noticias.titulo' | translate }}">
      <span class="badge-top-right" *ngIf="noticias.length > 0">{{
        noticias.length
        }}</span>
    </button>
    <ng-template #noticiasPopover>
      <div class="noticiasBox-body">
        <ng-container *ngFor="let noticia of noticias; let i = index; let ult = last">
          <ng-container *ngIf="i < 3">
            <div class="noticiaBox {{
                !ult && i < 2 ? 'noticiaBox-not-last' : ''
              }}" (click)="noticias_component.select_noticia(noticia)">
              <div class="text-muted small">
                <i class="fas fa-calendar"></i>
                {{ noticia.fecha | date: "MMMM dd, yyyy" }}
              </div>
              <img class="img-banner" src="{{ noticia.banner }}" />
              <br />
              <span class="text-primary">{{ noticia.nombre }}</span>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <div class="noticiasBox-footer" (click)="noticias_component.show_all_noticias()">
        {{
        (noticias.length > 0
        ? "noticias_avisos.mostrar_todas"
        : "noticias_avisos.noticias.empty"
        ) | translate
        }}
        {{ noticias.length > 0 ? "(" + noticias.length + ")" : "" }}
      </div>
    </ng-template>

    <!-- AVISOS -->
    <button pButton pRipple type="button" icon="{{ _config.getIcon('avisos') }}" class="p-ml-2 p-button-text p-sm"
      [ngClass]="
        !tokenError || avisos.length == 0 ? 'text-white button-header' : ''
      " [popover]="avisosPopover" popoverTitle="{{ 'noticias_avisos.avisos.titulo' | translate }}"
      containerClass="popoverHeader" [outsideClick]="true" *ngIf="config.SISTEMA.LOADS.AVISOS.BUTTON"
      [disabled]="tokenError" (click)="hideSidebar()" title="{{ 'noticias_avisos.avisos.titulo' | translate }}">
      <span class="badge-top-right" *ngIf="avisos.length > 0">{{
        avisos.length
        }}</span>
    </button>
    <ng-template #avisosPopover>
      <div class="avisosBox-body">
        <ng-container *ngFor="let aviso of avisos; let i = index; let ult = last">
          <ng-container *ngIf="i < 3">
            <div (click)="avisos_component.select_aviso({ data: aviso })">
              <div class="avisoBox {{ !ult && i < 2 ? 'avisoBox-not-last' : '' }}">
                <div class="text-muted small">
                  <i class="fas fa-calendar"></i>
                  {{ aviso.fecha | date: "MMMM dd, yyyy" }}
                </div>
                <span class="text-primary">{{ aviso.nombre }}</span><br />
                <span [innerHTML]="aviso.anuncio" class="small"></span>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <div class="avisosBox-footer" (click)="avisos_component.show_all_avisos()">
        {{
        (avisos.length > 0
        ? "noticias_avisos.mostrar_todas"
        : "noticias_avisos.avisos.empty"
        ) | translate
        }}
        {{ avisos.length > 0 ? "(" + avisos.length + ")" : "" }}
      </div>
    </ng-template>

    <!-- AYUDA -->

    <div class="btn-group" container="body" placement="bottom right" dropdown *ngIf="config.SISTEMA.LINKS.AYUDA.ACTIVO">

      <span class="text-white" style="margin-top: 5px;">Ayuda</span>
      <button pButton pRipple dropdownToggle type="button" icon="{{ _config.getIcon('ayuda') }}"
        class="p-button-rounded p-ml-2 p-button-text p-sm dropdown-toggle dropdown-not-caret" id="ayuda-dropdown"
        aria-controls="dropdown-ayuda-html" [ngClass]="!tokenError ? 'text-white button-header' : ''"
        title="{{ 'ayuda.nombre' | translate }}" [disabled]="tokenError" (click)="hideSidebar()"></button>
      <ul id="dropdown-ayuda-html" *dropdownMenu class="dropdown-menu dropdown-menu-right dropdown-header-custom"
        role="menu" aria-labelledby="ayuda-dropdown">
        <li role="menuitem" *ngIf="config.SISTEMA.LINKS.AYUDA.BUTTONS.CONTACTO">
          <a class="dropdown-item text-muted" (click)="contacto.show_contacto()">
            <i class="{{ _config.getIcon('contacto') }}"></i>
            {{ "ayuda.contacto.titulo" | translate }}
          </a>
        </li>
        <li role="menuitem" *ngIf="config.SISTEMA.LINKS.AYUDA.BUTTONS.SIMBOLOGIA">
          <a class="dropdown-item text-muted" (click)="simbologia_component.set_simbolos()">
            <i class="{{ _config.getIcon('simbologia') }}"></i>
            {{ "ayuda.simbologia.titulo" | translate }}
          </a>
        </li>
        <li role="menuitem" *ngIf="config.SISTEMA.LINKS.AYUDA.BUTTONS.PASO_A_PASO">
          <a class="dropdown-item text-muted" (click)="guia.set_guia()">
            <i class="{{ _config.getIcon('tutorial') }}"></i>
            {{ "ayuda.tutorial.nombre" | translate }}
          </a>
        </li>
      </ul>
    </div>

    <!-- MODULOS - APLICACIONES -->
    <button pButton pRipple type="button" icon="{{ _config.getIcon('modulos_aplicaciones') }}"
      class="p-button-rounded p-button-text p-sm p-ml-2" (click)="show_modulos_aplicaciones_sidebar()" *ngIf="
        config.SISTEMA.LOADS.APPS.BUTTON || config.SISTEMA.LOADS.MODULOS.BUTTON
      " [ngClass]="!tokenError ? 'text-white button-header' : ''" title="{{ 'mods_apps.titulo' | translate }}"
      [disabled]="tokenError"></button>

    <ng-container *ngIf="config.SISTEMA.LINKS.USUARIO.ACTIVO">
      <p-divider layout="vertical" class="d-none d-lg-block p-divider-header-right"></p-divider>

      <!-- USUARIO -->

      <div class="btn-group" container="body" placement="bottom right" dropdown>
        <p-avatar dropdownToggle image="{{ user_online?.foto }}" styleClass="rounded-circle img-profile"
          class="avatarUsuario dropdown-toggle dropdown-not-caret p-ml-3" shape="circle"
          *ngIf="config.SISTEMA.LINKS.USUARIO.ACTIVO" id="usuario-dropdown" aria-controls="dropdown-usuario-html"
          title="{{ 'usuario.profile.titulo' | translate }}" (click)="hideSidebar()"></p-avatar>
        <ul id="dropdown-usuario-html" *dropdownMenu
          class="dropdown-menu dropdown-menu-right dropdown-header-custom-usuario" role="menu"
          aria-labelledby="usuario-dropdown">
          <li role="menuitem" *ngIf="config.SISTEMA.LINKS.USUARIO.BUTTONS.PROFILE && !tokenError">
            <a class="dropdown-item text-muted" (click)="profile.show_profile()">
              <i class="{{ _config.getIcon('micuenta') }}"></i>
              {{ "usuario.profile.titulo" | translate }}
            </a>
          </li>
          <li role="menuitem" *ngIf="config.SISTEMA.LINKS.USUARIO.BUTTONS.CORREO">
            <a class="dropdown-item text-muted" (click)="goto_correo()">
              <i class="{{ _config.getIcon('correouv') }}"></i>
              {{ "usuario.profile.correo_uv" | translate }}
            </a>
          </li>
          <li role="menuitem" *ngIf="config.SISTEMA.LINKS.USUARIO.BUTTONS.CAMBIA_CLAVE">
            <a class="dropdown-item text-muted" (click)="goto_cambiaclave()">
              <i class="{{ _config.getIcon('cambiaclave') }}"></i>
              Cambia clave
            </a>
          </li>
          <ng-container *ngIf="config.SISTEMA.LINKS.USUARIO.BUTTONS.LOG_OUT">
            <li class="divider dropdown-divider"></li>
            <li role="menuitem">
              <a class="dropdown-item text-muted" (click)="logout()">
                <i class="{{ _config.getIcon('logout') }}"></i>
                {{ "usuario.logout" | translate }}
              </a>
            </li>
          </ng-container>
        </ul>
      </div>
    </ng-container>
  </div>
</p-toolbar>